<script setup>
import { useRoute, useState } from "#app";
import { get1688GoodsList, get1688ProductDetail, upload1688Img } from "@/api";
import { computed, onMounted, onBeforeMount, provide, ref, watch } from "vue";
import { getCurrencySymbol, getCurrencyNum } from "@/utils/goods";
import { get, set } from "lodash-es";
import { $t } from "~/utils/index.js";
import { localeTo1688CountryMap, isTarget_Blank } from "@/utils/globalData.js";
const { locale } = useI18n();
const lodashGet = get;
const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});
const state = reactive({
  detailData: {}
});
</script>

<template>
  <div  class="home-container">
   
    
    <div  class="content-wrapper">
      <div  class="home-wrapper min-content">
        <div  class="home-banner-wrapper">
          <div  class="home-banner-content width-max">
            <div  class="slogan">
              <div >购买所有来自1688的产品</div>
              <div  class="slogan-sub">服务有保障</div>
            </div>
             
            
          </div>
        </div>
        
        <div  class="shopping-service-wrapper width-max mb-20">
          
          <h2  class="module-title">一站式购物服务</h2>
          <div  class="shopping-service-list">
            
            <div   class="shopping-service-step-wrapper">
              <img
                
                class="step-img"
                src="https://hoobuy.com/_nuxt/stop_1.DrvWtniE.png"
                alt
              />
              <h6  class="step-title">下订单</h6>
              <div
                
                class="step-desc"
              >1.请选择左侧您要发货erp订单。<br/>2.有1688货源的商品直接跳转1688的产品下单,多个可加入购物车。<br/>没有设置货源的商品，粘贴您想要的产品的链接，多个商品可放入购物车一起下单，即可绑定我对应的erp订单。</div>
            </div>
            <img
              
              class="arrow-icon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA4AQMAAACmMWhBAAAABlBMVEUAAADwcAw2Kv/CAAAAAnRSTlMAVBqVWNUAAAAUSURBVBjTY/jPAAREEAOkcKCUAQCQLjfJVu26jAAAAABJRU5ErkJggg=="
              alt
            />
            <div   class="shopping-service-step-wrapper">
              <img
                
                class="step-img"
                src="https://hoobuy.com/_nuxt/stop_2.DshLz0Dh.png"
                alt
              />
              <h6  class="step-title">送货到我们的仓库</h6>
              <div
                
                class="step-desc"
              >通过我们的服务从不同的卖家购物，我们将高效地整合您的采购订单。所有商品将运送至对应仓库，简化流程。</div>
            </div>
            <img
              
              class="arrow-icon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA4AQMAAACmMWhBAAAABlBMVEUAAADwcAw2Kv/CAAAAAnRSTlMAVBqVWNUAAAAUSURBVBjTY/jPAAREEAOkcKCUAQCQLjfJVu26jAAAAABJRU5ErkJggg=="
              alt
            />
            <div   class="shopping-service-step-wrapper">
              <img
                
                class="step-img"
                src="https://hoobuy.com/_nuxt/stop_3.DXfgU1Jl.png"
                alt
              />
              <h6  class="step-title">丝滑服务</h6>
              <div
                
                class="step-desc"
              >一旦您的产品开始发往仓库，它们就会自动预报物流单号到erp系统实时同步最新的国内物流信息。</div>
            </div>
            <img
              
              class="arrow-icon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA4AQMAAACmMWhBAAAABlBMVEUAAADwcAw2Kv/CAAAAAnRSTlMAVBqVWNUAAAAUSURBVBjTY/jPAAREEAOkcKCUAQCQLjfJVu26jAAAAABJRU5ErkJggg=="
              alt
            />
            <div   class="shopping-service-step-wrapper">
              <img
                
                class="step-img"
                src="https://hoobuy.com/_nuxt/stop_4.v2ilN5a3.png"
                alt
              />
              <h6  class="step-title">全球运输变得简单</h6>
              <div
                
                class="step-desc"
              >仓库将它们整合到一个包裹中。借助我们可靠的全球运输服务，您可以高效购买的商品发往您的客户地址，享受世界级运输的便利。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
   
  </div>
</template>

<style lang="less" scoped>

.home-banner-wrapper {
    align-items: center;
    background: #131926 url(https://cdn.static.hoobuy.com/assets/home/banner_bg.webp) no-repeat 50%;
    background-size: cover;
    display: flex;
    height: 210px;
    margin-top: -80px;
    padding-top: 80px
  }
  
  .home-banner-wrapper .home-banner-content {
    flex: 1;
    padding-left: 56px
  }
  
  .home-banner-wrapper .slogan {
    color: #fff;
    font-size: 48px;
    font-weight: 900;
    line-height: 64px;
    margin-bottom: 24px;
    max-width: 800px
  }
  
  .home-banner-wrapper .slogan .slogan-sub {
    animation: gradientMove-943ef3ea 3s linear infinite;
    -webkit-background-clip: text;
    background-clip: text;
    background-image: linear-gradient(89.72deg,#ffb800 .24%,#ffefb8 19.71%,#ffb800 38.19%,#ffefb8 57.42%,#ffb800 72.33%,#ffefb8 85.76%,#ffb800 101.44%);
    background-size: 200% 100%;
    color: transparent;
    cursor: pointer;
    display: inline-block;
    position: relative
  }
  
  .home-banner-wrapper .slogan .slogan-sub:after {
    background: url(https://cdn.static.hoobuy.com/assets/activity/20250421-103154.gif) no-repeat 50%;
    background-size: contain;
    content: "";
    display: inline-block;
    height: 45px;
    margin-left: 8px;
    vertical-align: middle;
    width: 45px
  }
  
  .home-banner-wrapper .slogan .slogan-sub:before {
    background-color: #ffb800;
    bottom: -4px;
    content: "";
    height: 2px;
    left: 0;
    opacity: 0;
    position: absolute;
    transition: opacity .3s;
    width: 100%
  }
  
  .home-banner-wrapper .slogan .slogan-sub:hover:before {
    opacity: 1
  }
  
  @keyframes gradientMove-943ef3ea {
    0% {
        background-position: 0 0
    }
  
    to {
        background-position: 100% 0
    }
  }
  
  .shopping-service-step-wrapper {
    flex: 1
  }
  
  .shopping-service-step-wrapper .step-img {
    display: block;
    height: 120px;
    margin: 0 auto;
    width: 171px
  }
  
  .shopping-service-step-wrapper .step-title {
    color: var(--text-02);
    font-size: 18px;
    font-weight: 900;
    line-height: 60px;
    text-align: center
  }
  
  .shopping-service-step-wrapper .step-desc {
    color: var(--text-01);
    font-size: 14px;
    line-height: 24px
  }
  
  .shopping-service-wrapper{
    margin-top: 24px
  }
  
  .shopping-service-wrapper .banner-wrapper{
    position: relative
  }
  
  .shopping-service-wrapper .module-title{
    color: var(--text);
    font-size: 36px;
    font-weight: 700;
    line-height: 60px;
    margin-top: 18px;
    text-align: center
  }
  
  .shopping-service-wrapper .shopping-service-list{
    -moz-column-gap: 24px;
    column-gap: 24px;
    display: flex;
    margin-top: 18px;
    padding:0 25px;
  }
  
  .shopping-service-wrapper .arrow-icon{
    flex: 0 0 16px;
    height: 28px;
    margin: 66px 10px 0;
    width: 16px
  }
</style>

